module.exports = /******/
function(modules) {
    /******/
    /******/
    // The require function
    /******/
    function __webpack_require__(moduleId) {
        /******/
        /******/
        // Check if module is in cache
        /******/
        if (installedModules[moduleId]) /******/
        return installedModules[moduleId].exports;
        /******/
        /******/
        // Create a new module (and put it into the cache)
        /******/
        var module = installedModules[moduleId] = {
            /******/
            exports: {},
            /******/
            id: moduleId,
            /******/
            loaded: !1
        };
        /******/
        /******/
        // Return the exports of the module
        /******/
        /******/
        /******/
        // Execute the module function
        /******/
        /******/
        /******/
        // Flag the module as loaded
        /******/
        return modules[moduleId].call(module.exports, module, module.exports, __webpack_require__), 
        module.loaded = !0, module.exports;
    }
    // webpackBootstrap
    /******/
    // The module cache
    /******/
    var installedModules = {};
    /******/
    /******/
    // Load entry module and return exports
    /******/
    /******/
    /******/
    /******/
    // expose the modules object (__webpack_modules__)
    /******/
    /******/
    /******/
    // expose the module cache
    /******/
    /******/
    /******/
    // __webpack_public_path__
    /******/
    return __webpack_require__.m = modules, __webpack_require__.c = installedModules, 
    __webpack_require__.p = "", __webpack_require__(0);
}([ /* 0 */
/***/
function(module, exports, __webpack_require__) {
    module.exports = __webpack_require__(1);
}, /* 1 */
/***/
function(module, exports, __webpack_require__) {
    "use strict";
    function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
            default: obj
        };
    }
    Object.defineProperty(exports, "__esModule", {
        value: !0
    }), exports.default = void 0;
    var _InlineDialog = __webpack_require__(2), _InlineDialog2 = _interopRequireDefault(_InlineDialog);
    exports.default = _InlineDialog2.default;
}, /* 2 */
/***/
function(module, exports, __webpack_require__) {
    "use strict";
    function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
            default: obj
        };
    }
    Object.defineProperty(exports, "__esModule", {
        value: !0
    });
    var _classCallCheck2 = __webpack_require__(3), _classCallCheck3 = _interopRequireDefault(_classCallCheck2), _possibleConstructorReturn2 = __webpack_require__(4), _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2), _inherits2 = __webpack_require__(5), _inherits3 = _interopRequireDefault(_inherits2), _propTypes = __webpack_require__(6), _propTypes2 = _interopRequireDefault(_propTypes), _react = __webpack_require__(7), _react2 = _interopRequireDefault(_react), _reactDom = __webpack_require__(8), _reactDom2 = _interopRequireDefault(_reactDom), _layer = __webpack_require__(9), _layer2 = _interopRequireDefault(_layer), _utilSharedStyles = __webpack_require__(10), _Container = __webpack_require__(11), _Container2 = _interopRequireDefault(_Container), dialogOffset = "0 " + _utilSharedStyles.akGridSizeUnitless, positions = [ "top left", "top center", "top right", "right top", "right middle", "right bottom", "bottom left", "bottom center", "bottom right", "left top", "left middle", "left bottom" ], flipPositions = [ "top", "right", "bottom", "left" ], InlineDialog = function(_PureComponent) {
        function InlineDialog() {
            var _temp, _this, _ret;
            (0, _classCallCheck3.default)(this, InlineDialog);
            for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) args[_key] = arguments[_key];
            return _temp = _this = (0, _possibleConstructorReturn3.default)(this, _PureComponent.call.apply(_PureComponent, [ this ].concat(args))), 
            _this.componentDidMount = function() {
                document.addEventListener("click", _this.handleClickOutside);
            }, _this.componentWillUnmount = function() {
                document.removeEventListener("click", _this.handleClickOutside);
            }, _this.handleClickOutside = function(event) {
                if (_this.props.isOpen) {
                    var domNode = _reactDom2.default.findDOMNode(_this);
                    // eslint-disable-line react/no-find-dom-node
                    (!domNode || event.target instanceof Node && !domNode.contains(event.target)) && _this.props.onClose({
                        isOpen: !1,
                        event: event
                    });
                }
            }, _ret = _temp, (0, _possibleConstructorReturn3.default)(_this, _ret);
        }
        return (0, _inherits3.default)(InlineDialog, _PureComponent), InlineDialog.prototype.render = function() {
            var _props = this.props, children = _props.children, content = _props.content, isOpen = _props.isOpen, onContentBlur = _props.onContentBlur, onContentClick = _props.onContentClick, onContentFocus = _props.onContentFocus, position = _props.position, shouldFlip = _props.shouldFlip, layerContent = isOpen ? _react2.default.createElement(_Container2.default, {
                onBlurCapture: onContentBlur,
                onClick: onContentClick,
                onFocusCapture: onContentFocus,
                tabIndex: "-1"
            }, content) : null;
            return _react2.default.createElement(_layer2.default, {
                autoFlip: shouldFlip,
                content: layerContent,
                offset: dialogOffset,
                position: position
            }, _react2.default.createElement("div", null, children));
        }, InlineDialog;
    }(_react.PureComponent);
    InlineDialog.propTypes = {
        /** The elements that the InlineDialog will be positioned relative to. */
        children: _propTypes2.default.node,
        /** The elements to be displayed within the InlineDialog. */
        content: _propTypes2.default.node,
        /** Sets whether to show or hide the dialog. */
        isOpen: _propTypes2.default.bool,
        /** Function called when you lose focus on the object. */
        onContentBlur: _propTypes2.default.func,
        /** Function called when you click on the open dialog. */
        onContentClick: _propTypes2.default.func,
        /** Function called when you focus on the open dialog. */
        onContentFocus: _propTypes2.default.func,
        /** Function called when the dialog is open and a click occurs anywhere outside
	  the dialog. Calls with an object { isOpen: false } and the type of event that
	  triggered the close. */
        onClose: _propTypes2.default.func,
        /** Where the dialog should appear, relative to the contents of the children. */
        position: _propTypes2.default.oneOf(positions),
        /** Whether the dialog's position should be altered when there is no space
	  for it in its default position. If an array is passed, it will use the first
	  position where there is enough space, displaying in the last position if none
	  have enough space. */
        shouldFlip: _propTypes2.default.oneOfType([ _propTypes2.default.bool, _propTypes2.default.arrayOf(_propTypes2.default.oneOf(flipPositions)) ])
    }, InlineDialog.defaultProps = {
        isOpen: !1,
        onContentBlur: function() {},
        onContentClick: function() {},
        onContentFocus: function() {},
        onClose: function() {},
        position: "bottom center",
        shouldFlip: !1
    }, exports.default = InlineDialog;
}, /* 3 */
/***/
function(module, exports) {
    module.exports = require("babel-runtime/helpers/classCallCheck");
}, /* 4 */
/***/
function(module, exports) {
    module.exports = require("babel-runtime/helpers/possibleConstructorReturn");
}, /* 5 */
/***/
function(module, exports) {
    module.exports = require("babel-runtime/helpers/inherits");
}, /* 6 */
/***/
function(module, exports) {
    module.exports = require("prop-types");
}, /* 7 */
/***/
function(module, exports) {
    module.exports = require("react");
}, /* 8 */
/***/
function(module, exports) {
    module.exports = require("react-dom");
}, /* 9 */
/***/
function(module, exports) {
    module.exports = require("@atlaskit/layer");
}, /* 10 */
/***/
function(module, exports) {
    module.exports = require("@atlaskit/util-shared-styles");
}, /* 11 */
/***/
function(module, exports, __webpack_require__) {
    "use strict";
    function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
            default: obj
        };
    }
    Object.defineProperty(exports, "__esModule", {
        value: !0
    });
    var _taggedTemplateLiteral2 = __webpack_require__(12), _taggedTemplateLiteral3 = _interopRequireDefault(_taggedTemplateLiteral2), _templateObject = (0, 
    _taggedTemplateLiteral3.default)([ "\n  background: ", ";\n  border-radius: ", ";\n  box-shadow: 0 0 1px ", ",  0 4px 8px -2px ", ";\n  box-sizing: border-box;\n  color: ", ";\n  max-height: ", "px;\n  max-width: ", "px;\n  padding: ", "px;\n  z-index: 200;\n" ], [ "\n  background: ", ";\n  border-radius: ", ";\n  box-shadow: 0 0 1px ", ",  0 4px 8px -2px ", ";\n  box-sizing: border-box;\n  color: ", ";\n  max-height: ", "px;\n  max-width: ", "px;\n  padding: ", "px;\n  z-index: 200;\n" ]), _styledComponents = __webpack_require__(13), _styledComponents2 = _interopRequireDefault(_styledComponents), _utilSharedStyles = __webpack_require__(10), _theme = __webpack_require__(14), _theme2 = _interopRequireDefault(_theme);
    exports.default = _styledComponents2.default.div(_templateObject, _theme2.default.light.background, _utilSharedStyles.akBorderRadius, _theme2.default.light.border, _theme2.default.light.shadow, _theme2.default.light.text, 60 * _utilSharedStyles.akGridSizeUnitless, 62 * _utilSharedStyles.akGridSizeUnitless, 3 * _utilSharedStyles.akGridSizeUnitless);
}, /* 12 */
/***/
function(module, exports) {
    module.exports = require("babel-runtime/helpers/taggedTemplateLiteral");
}, /* 13 */
/***/
function(module, exports) {
    module.exports = require("styled-components");
}, /* 14 */
/***/
function(module, exports, __webpack_require__) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
        value: !0
    });
    var _utilSharedStyles = __webpack_require__(10), akColorDN50 = "#283447", akColorDN600 = "#B8C7E0";
    exports.default = {
        light: {
            background: _utilSharedStyles.akColorN0,
            border: _utilSharedStyles.akColorN60A,
            shadow: _utilSharedStyles.akColorN50A,
            text: _utilSharedStyles.akColorN800
        },
        dark: {
            background: akColorDN50,
            shadow: _utilSharedStyles.akColorN50A,
            text: akColorDN600
        }
    };
} ]);


//////////////////
// WEBPACK FOOTER
// ../inline-dialog/dist/bundle-cjs.js
// module id = 247
// module chunks = 0